/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { App } from 'antd';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Toolbar, useMediaQuery } from '@mui/material';

import { setMessageNotification } from 'store/features/profile/profileSlice';
import { setDataTableReset, setSocketReducer } from 'store/reducer/mainSlice';
// project import
// import navigation from "menu-items";
// import Breadcrumbs from "components/@extended/Breadcrumbs";
import { openDrawer } from 'store/features/menu/menuSlice';
import MainDrawer from './Drawer/Drawer';
import Header from './Header/Header';
import { useGetMenuCountMutation, useGetMenuByModuleQuery } from 'store/features/menu/menuApi';
import { socket } from 'utils/socket';
import { useGetSelfAuthorizationQuery } from 'store/features/auth/authApi';
import { useGetNotificationCountMutation } from 'store/features/process/processApi';
import { setReminderNotification } from 'store/features/process/processSlice';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

const usePreviousPath = () => {
	const location = useLocation();
	const previousPath = useRef(null);

	const comparePaths = (currentPath) => {
		const currentSegments = currentPath?.split('/');
		const prevSegments = previousPath?.current?.split('/');

		const minLength = Math.min(prevSegments?.length, currentSegments.length);

		for (let i = 0; i < minLength; i++) {
			if (prevSegments[i] !== currentSegments[i]) {
				return false;
			}
		}

		return true;
	};

	useEffect(() => {
		previousPath.current = location.pathname;
	}, [location]);

	return { comparePaths };
};

// import axios from 'axios';

const isPageNeedFullHight = (path) => ['/conversation', '/process-form'].includes(path);
const mainDiveWidthConsideringVerticalScrollBar = (scrollbar, drawerWidth) => {
	let width = document.documentElement.clientWidth - scrollbar;
	if (width > 1024) {
		return width - drawerWidth;
	}

	return width;
};
// ==============================|| MAIN LAYOUT ||============================== //

const MainContent = ({ children, sx }) => {
	const drawerOpen = useSelector((state) => state.menu.drawerOpen);
	const [windowWidth, setWindowWidth] = useState(document.documentElement.clientWidth);
	const [scrollbar, setScrollbar] = useState(0);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(document.documentElement.clientWidth);
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		// const bodyElement = document.documentElement;
		const bodyElement = document.body;

		const observer = new ResizeObserver(() => {
			// const hasVerticalScrollbar = document.documentElement.scrollHeight > window.innerHeight;
			const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
			if (scrollBarWidth) {
				setScrollbar(true);
			} else {
				setScrollbar(false);
			}
		});

		// Observe the body element for size changes
		if (observer) {
			observer.observe(bodyElement);
		}

		// Cleanup the observer on unmount
		return () => {
			if (observer) {
				observer.disconnect();
			}
		};
	}, []);

	return (
		<Box
			component="main"
			sx={{
				width: mainDiveWidthConsideringVerticalScrollBar(scrollbar, drawerOpen ? DRAWER_WIDTH : MINI_DRAWER_WIDTH),
				overflowX: 'clip',
				flexGrow: 1,
				backgroundColor: 'background.main',
				p: { xs: 2, sm: 3 },
				pt: { xs: 3 },
				...sx,
			}}
		>
			{children}
		</Box>
	);
};

const MainLayout = () => {
	const theme = useTheme();
	const dispatch = useDispatch();
	const matchDownLG = useMediaQuery(theme.breakpoints.down('lg'));
	const { pathname } = useLocation();
	const selectedModule = useSelector((state) => state.menu.selectedModule);
	const { data: getMenuRes } = useGetMenuByModuleQuery(selectedModule);

	const navigate = useNavigate();
	const [getMenuCount] = useGetMenuCountMutation();
	const [GetNotificationCount] = useGetNotificationCountMutation();
	const userId = useSelector((state) => state.auth.userId);
	const roleId = useSelector((state) => state.auth.roleId);
	const accessToken = useSelector((state) => state.auth.accessToken);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const unreadMessageCount = useSelector((state) => state?.profile?.unreadMessageCount);
	const unreadReminderNotificationCount = useSelector((state) => state?.process?.unreadReminderNotificationCount);
	const [callProfileApi, setCallProfileApi] = useState(true);

	useGetSelfAuthorizationQuery(userId, {
		skip: callProfileApi,
	});
	const { message: messageApi } = App.useApp();

	// set media wise responsive drawer

	useEffect(() => {
		dispatch(openDrawer({ drawerOpen: !matchDownLG }));
	}, [matchDownLG]);

	// useEffect(() => {
	//   if (apiMenuItems?.length === 0) {
	//     getMenu({});
	//   }
	//   //eslint-disable-next-line
	// }, []);

	const menuCountHandler = useCallback(() => {
		getMenuCount({
			module: !selectedModule || selectedModule === 'GLOBAL' ? null : selectedModule,
			processCode: null,
		});
	}, [selectedModule]);

	useEffect(() => {
		if (getMenuRes?.result?.status?.toLowerCase() === 'success') {
			menuCountHandler();
		}
	}, [selectedModule, getMenuRes]);

	useEffect(() => {
		if (roleId && accessToken && userId) {
			setCallProfileApi(false);
		}
	}, [accessToken, roleId, userId]);

	//************************** NEW SOCKET **************************//
	useEffect(() => {
		if (companyCode) {
			socket.connect();
		}

		return () => {
			socket.disconnect();
		};
	}, [companyCode]);

	useEffect(() => {
		let _onConnect = () => {
			// console.log('Socket Connected');
			if (userId && companyCode && accessToken && socket.id) {
				// if (heartbeatIntervalId.current) {
				//   clearInterval(heartbeatIntervalId.current);
				// }
				// console.log("connected-2", companyCode, socket.id);
				socket.emit('user_in', { userId, companyCode, token: accessToken, socketId: socket.id });

				dispatch(setSocketReducer());

				messageApi.success({
					content: 'Your Are Connected',
				});

				// heartbeatIntervalId.current = setInterval(() => {
				//   console.log("heartbeat", new Date(), "heartbeatId", heartbeatIntervalId.current);
				//   socket.emit("heartbeat", { userId, companyCode, token: accessToken, socketId: socket.id });
				// }, 10000);
			}
			// console.log("heartbeatId", heartbeatIntervalId.current);
		};

		let _onDisconnect = () => {
			// console.log("heartbeatId", heartbeatIntervalId.current);
			// clearInterval(heartbeatIntervalId.current);
			// console.log("reason", reason);
			messageApi.error({
				content: 'Your Are Disconnected',
				// icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: "8px", verticalAlign: "sub" }} />,
			});
		};

		// let _onSetSocketId = (data) => {
		//   console.log("data from server", data);
		//   socket.id = data;
		// };

		// let _onLogoutDisconnectionUser = () => {
		// 	navigate('/login');
		// };

		let _onCommunicate = (res) => {
			console.log('communicate -- count', res);
			if (res?.data?.type === 'box') {
				if (selectedModule == res?.data?.moduleCode) {
					menuCountHandler();
				} else if (selectedModule === 'GLOBAL') {
					menuCountHandler();
				}
			} else if (res?.data?.type === 'notification') {
				GetNotificationCount();
			} else if (res?.data?.type === 'message') {
				dispatch(
					setMessageNotification({
						unreadMessageCount: unreadMessageCount + 1,
					})
				);
			} else if (res?.data?.type === 'reminder') {
				console.log('Reminder found!');

				dispatch(
					setReminderNotification({
						unreadReminderNotificationCount: unreadReminderNotificationCount + 1,
					})
				);
			}
		};

		let _onHeartbeat = () => {
			console.count('heartbeat');
			socket.emit('heartbeat', { userId, companyCode, token: accessToken, socketId: socket.id });
		};

		socket.on('connect', _onConnect);
		socket.on('disconnect', _onDisconnect);
		// we manage it vai window API
		// socket.on('logout-disconnection-user', _onLogoutDisconnectionUser);
		socket.on('communicate', _onCommunicate);
		socket.on('heartbeat', _onHeartbeat);

		return () => {
			socket.off('connect', _onConnect);
			socket.off('disconnect', _onDisconnect);
			// socket.off('logout-disconnection-user', _onLogoutDisconnectionUser);
			socket.off('communicate', _onCommunicate);
			socket.off('heartbeat', _onHeartbeat);
		};
	}, [userId, companyCode, accessToken, socket.id, messageApi]);

	const { comparePaths } = usePreviousPath();

	const isMatch = comparePaths(pathname);

	useEffect(() => {
		if (!isMatch) {
			dispatch(setDataTableReset());
		}
	}, [isMatch]);

	const checkRoute = ({ pathname }) => {
		const pathList = ['/form-builder', '/comptroller/work-flow/'];

		// return pathList?.includes(pathname);

		return pathList.some((path) => pathname.startsWith(path));
	};

	useEffect(() => {
		const handleStorage = (event) => {
			if (event.key === 'lyn:logout') {
				window.location.reload();
			}
		};

		window.addEventListener('storage', handleStorage);
		return () => window.removeEventListener('storage', handleStorage);
	}, []);

	return (
		<Box sx={{ display: 'flex', width: '100%', overflowX: 'clip', height: isPageNeedFullHight(pathname) ? '100%' : 'auto' }}>
			<Header />
			<MainDrawer />

			{/* {apiMenuItems?.length > 0 && ( */}
			{/* <MainContent sx={pathname === '/form-builder' ? { p: 0 } : {}}> */}
			<MainContent sx={checkRoute({ pathname }) ? { p: 0 } : {}}>
				{/* {pathname !== '/form-builder' && <Toolbar />} */}
				{!checkRoute({ pathname }) && <Toolbar />}
				{/* <Breadcrumbs navigation={apiMenuObj} title /> */}
				<Outlet context={useOutletContext()} />
			</MainContent>
			{/* )} */}
		</Box>
	);
};

export default MainLayout;
